/**
 * Find all elements of iterator that are not present in another iterator
 *
 * @param iterator1 Set 1
 * @param iterator2 Set 2
 * @return all elements of iterator 1 that are not in iterator 2.
 */
export function difference<T>(
  iterator1: Iterable<T>,
  iterator2: Iterable<T>
): Set<T> {
  const diff = new Set<T>();

  const removed =
    iterator2 instanceof Set ? iterator2 : new Set([...iterator2]);
  for (const element of iterator1) {
    if (!removed.has(element)) {
      diff.add(element);
    }
  }

  return diff;
}
